/**
 * 說明 : 使用者資料與後端調用的非同步行為
 */

// ----- import from redux toolkit -----
import { createAsyncThunk } from "@reduxjs/toolkit";

// ----- import from Base API -----
import BaseAPI from "./BaseAPI";

// 新增使用者
export const addUser = createAsyncThunk(
    "user/addUser",
    async (userInfo, { getState, rejectWithValue }) => {
        try {
            const token = getState().auth.token;
            const data = await BaseAPI.postWithAuth("/setting/user", userInfo, token);
            return data;
        } catch (err) {
            console.error('add user error', err.response.data);
            return rejectWithValue(err.response.data);
        }
    }
);

// 修改使用者
export const editUser = createAsyncThunk(
    "user/editUser",
    async (userInfo, { getState, rejectWithValue }) => {
        try {
            const token = getState().auth.token;
            const data = await BaseAPI.putWithAuth("/setting/user", userInfo, token);
            return data;
        } catch (err) {
            console.error('edit user error', err.response.data);
            return rejectWithValue(err.response.data);
        }
    }
);

// 修改使用者狀態
export const editUserStatus = createAsyncThunk(
    "user/editUserStatus",
    async ({userIds, status }, { getState, rejectWithValue }) => {
        try {
            const token = getState().auth.token;
            const data = await BaseAPI.putWithAuth("/setting/user/status", {userIds: userIds, flgStatus: status }, token);
            return data;
        } catch (err) {
            console.error('edit user status error', err.response.data);
            return rejectWithValue(err.response.data);
        }
    }
);

// 修改使用者密碼
export const editUserPassword = createAsyncThunk(
    "user/editUserPassword",
    async ({ userId, oldPassword, newPassword }, { getState, rejectWithValue }) => {
        try {
            const token = getState().auth.token;
            const data = await BaseAPI.putWithAuth("/setting/user/password", {userId: userId, oldPassword: oldPassword, newPassword: newPassword }, token);
            return data;
        } catch (err) {
            console.error('edit user password error', err.response.data);
            return rejectWithValue(err.response.data);
        }
    }
);

// 刪除使用者
export const deleteUser = createAsyncThunk(
    "user/deleteUser",
    async (userIds, { getState, rejectWithValue }) => {
        try {
            const token = getState().auth.token;
            const data = await BaseAPI.deleteWithAuth(`/setting/user/${userIds}`, null, token);
            return data;
        } catch (err) {
            console.error('delete user error', err.response.data);
            return rejectWithValue(err.response.data);
        }
    }
);

// 取得單筆使用者資料
export const fetchUser = createAsyncThunk(
    "user/fetchUser",
    async (userId, { getState, rejectWithValue }) => {
        try {
            const token = getState().auth.token;
            const data = await BaseAPI.getWithAuth(`/setting/user/${userId}`, token);
            return data;
        } catch (err) {
            console.error('fetch user error', err.response.data);
            return rejectWithValue(err.response.data);
        }
    }
);

// 取得使用者清單列表
export const fetchUserList = createAsyncThunk(
    "user/fetchUserList",
    async ({ buildingId, userName, roleId }, { getState, rejectWithValue }) => {
        try {
            const token = getState().auth.token;
            const data = await BaseAPI.getWithAuth("/setting/user", { buildingId: buildingId, userName: userName, roleId: roleId }, token);
            return data;
        } catch (err) {
            console.error('fetch user list error', err.response.data);
            return rejectWithValue(err.response.data);
        }
    }
);